import { createContext, useContext } from 'react'
import { allows } from '@/app/viewAccess'
import type { Permissions } from '@/app/viewAccess'

/** The signed-in user's grants (see app/viewAccess.ts). */
export const PermissionsContext = createContext<Permissions>(null)

/**
 * Whether the signed-in user may do something, e.g. `useCan('action:decide')` before showing
 * approve and dismiss (SDK 1.9). The API refuses it either way; this only keeps buttons that
 * would fail off the screen. True when the platform knows no permissions.
 */
export function useCan(permission: string): boolean {
    return allows(useContext(PermissionsContext), permission)
}
